module.exports = __webpack_public_path__ + "img/gallery-icon-02.6ea28015.png";